import classNames from 'classnames'

import { DocumentProcessingStatusType, type DocumentRecord } from '../../../models/Document'

import { selectContactChanges } from '../../../store/meetingSummary/contactUpdate'
import { selectDocumentSummaryResultLoading, selectDocumentSummarySyncStatus } from '../../../store/processDocument/document'
import { useAppSelector } from '../../../store/hooks'

import { DOCUMENT_PROCESSING_STATUS_ICON_CLASS_NAME_MAPPING, DOCUMENT_PROCESSING_STATUS_ICON_MAPPING, DOCUMENT_PROCESSING_STATUS_TEXT_MAPPING } from './models'

import './DocumentProcessingStatus.scss'

interface InlineDocumentProcessingStatusProps {
  document: DocumentRecord
}

export const InlineDocumentProcessingStatus: React.FC<InlineDocumentProcessingStatusProps> = ({ document }) => {
  const summaryResultLoading = useAppSelector(selectDocumentSummaryResultLoading)
  const summarySyncStatus = useAppSelector(selectDocumentSummarySyncStatus)
  const contactChanges = useAppSelector(selectContactChanges)

  const documentIsProcessing = !document.summaryProcessing.finishedAt
  const documentIsSaved = !!summarySyncStatus.length || contactChanges.some((contactChange) => contactChange.syncStatus?.length)

  const processingStatusType = documentIsProcessing
    ? DocumentProcessingStatusType.PROCESSING
    : summaryResultLoading
      ? DocumentProcessingStatusType.LOADING
      : documentIsSaved
        ? DocumentProcessingStatusType.SAVED
        : DocumentProcessingStatusType.READY

  return (
    <div className='d-flex align-items-center gap-2 flex-shrink-0'>
      <div
        className={classNames(
          'document-processing-icon-container d-flex align-items-center justify-content-center',
          DOCUMENT_PROCESSING_STATUS_ICON_CLASS_NAME_MAPPING[processingStatusType],
        )}
      >
        {DOCUMENT_PROCESSING_STATUS_ICON_MAPPING[processingStatusType]}
      </div>
      <span className='text-nowrap'>{DOCUMENT_PROCESSING_STATUS_TEXT_MAPPING[processingStatusType]}</span>
    </div>
  )
}
